import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import {DepartamentoService} from 'src/app/services/departamento.service';
import {AuthenticationService} from 'src/app/services/authentication.service';
import {Router, ActivatedRoute} from '@angular/router';
import {Auth} from 'src/app/models/auth';
import {DepartamentoCadastro} from 'src/app/models/departamento-cadastro';
import {GenericValidator} from 'src/app/shared/validators/generic-validator.validator';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-departamento-create',
    templateUrl: './departamento-create.component.html',
    styleUrls: ['./departamento-create.component.css']
})
export class DepartamentoCreateComponent implements OnInit {

    constructor(
        private formBuilder: FormBuilder,
        private departamentoService: DepartamentoService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute) {}

    private currentUser: Auth;
    departamentoCadastro: DepartamentoCadastro;

    departamentoFormGroup: FormGroup;

    public get form() {
        return this.departamentoFormGroup.controls;
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        // usar para criar / editar
        // validar se foi para esse componente com o id do centro de custo (sim = editar) (não = cadastrar)
        this.createForm(new DepartamentoCadastro('', ''));
    }

    createForm(departamentoCadastro: DepartamentoCadastro) {
        this.departamentoFormGroup = this.formBuilder.group({
            nome: new FormControl(departamentoCadastro.nome, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            codigo: new FormControl(departamentoCadastro.codigo, [
                Validators.required,
                Validators.maxLength(15)
            ])
        });
    }

    onSubmit(departamentoCadastro: DepartamentoCadastro) {
        if (this.departamentoFormGroup.valid) {
            this.departamentoService.add(departamentoCadastro, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.alertService.success(response.message, true);
                        this.router.navigate(['list'], {relativeTo: this.route.parent});
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                }
            );
        } else {
            GenericValidator.verifierValidatorsForm(this.departamentoFormGroup);
        }
    }

}
